import React, { ReactNode } from 'react';
import { HighlightWithinTextarea } from 'react-highlight-within-textarea'
import clsx from 'clsx';
import styles from './Input.module.scss';

type TextareaProps = {
  className?: string,
  onChange: (v: string) => void,
  onClick?: (e: React.FormEvent<HTMLTextAreaElement>) => void,
  value?: string,
  disabled?: boolean,
  gray?: boolean,
  rows?: number,
  placeholder?: string,
  icon?: ReactNode,
  error?: boolean,
  errorMessage?: string,
  onBlur?: () => void,
  maxLength?: number | undefined,
  maxHashtag?: number | undefined,
  wide?: boolean,
  width?: string,
  withHighlight?: boolean,
}

function Input({
  className = '',
  value = '',
  onChange,
  disabled = false,
  gray = false,
  placeholder = '',
  error = false,
  errorMessage = '',
  maxLength,
  maxHashtag,
  wide = true,
  withHighlight = false,
  width = 'auto',
  ...restInputProps
}: TextareaProps) {
  return (
    <>
      <div
        className={clsx(
          styles.containerTextarea,
          className,
          disabled && styles.containerDisabled,
          (value === '') && styles.containerEmpty,
          wide && styles.containerWide,
          error && styles.error,
          gray && styles.containerTextareaGray,
        )}
      >
        {withHighlight ? (
          <div
            className={clsx(styles.textareaWithHighlight)}
            style={{ width }}
          >
            <div className="scroll">
              <HighlightWithinTextarea
                value={value}
                placeholder={placeholder}
                highlight={[{
                  highlight: /#[^(\s,.;)]*/g,
                  className: styles.textareaHighlight,
                }]}
                {...restInputProps}
                onChange={(v: string) => {
                  if (!disabled) {
                    let res = v
                    if (maxHashtag) {
                      const tags = v.match(/#[^(\s,.;)]*/g) || []
                      if (tags.length > maxHashtag) {
                        res = v.split(/#[^(\s,.;)]*/g)
                          .map((s: string, idx: number) => (
                            (idx < maxHashtag) ? `${s}${tags[idx]}` : s
                          )).join('')
                      }
                    }
                    onChange(maxLength ? res.slice(0, maxLength) : res)
                  }
                }}
              />
            </div>
          </div>
        ) : (
          <textarea
            value={value}
            className={clsx(styles.textarea, 'scroll', gray && styles.textareaGray)}
            disabled={disabled}
            placeholder={placeholder}
            maxLength={maxLength}
            {...restInputProps}
            onChange={(e: React.FormEvent<HTMLTextAreaElement>) => (
              onChange((e.target as HTMLTextAreaElement).value)
            )}
          />
        )}
      </div>
      {(error && errorMessage) && (
        <div className={styles.errorMessage}>{errorMessage}</div>
      )}
    </>
  )
}

export default Input
